import React from "react";
import DataTable from "../../../Common/DataTable";
import { StatusBadge } from "../../../ui";

/**
 * UsersTab — List users belonging to this institute.
 */
const UsersTab = ({ users = [], loading = false }) => {
  const columns = [
    {
      key: "name",
      label: "Name",
      render: (row) => (
        <div>
          <div className="fw-medium" style={{ fontSize: "0.8125rem" }}>{row.name}</div>
          <div className="text-muted" style={{ fontSize: "0.6875rem" }}>{row.email || row.mobile}</div>
        </div>
      ),
    },
    { key: "role", label: "Role", render: (row) => <span className="text-capitalize">{row.usertype || row.role}</span> },
    {
      key: "status",
      label: "Status",
      render: (row) => (
        <StatusBadge status={row.status === "active" ? "active" : "inactive"}>
          {row.status || "Active"}
        </StatusBadge>
      ),
    },
    {
      key: "createdAt",
      label: "Joined",
      render: (row) =>
        row.createdAt ? new Date(row.createdAt).toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata" }) : "—",
    },
  ];

  return (
    <div className="sa-detail-tab">
      <DataTable
        data={users}
        columns={columns}
        loading={loading}
        emptyMessage="No users found for this institute"
      />
    </div>
  );
};

export default UsersTab;
